(function () {
  var requestCopy = {
    call: {
      name: "Service Call",
      watch: "Assistance Request"
    },
    bill: {
      name: "Bill Request",
      watch: "Bill Request"
    }
  };

  var phaseCopy = {
    idle: ["01", "System ready", "Press Call or Bill on the lamp base"],
    pressed: ["02", "Request captured", "The table button confirms the touch"],
    sending: ["03", "Signal in motion", "A discreet request travels to the team"],
    received: ["04", "Receiver notified", "The table number lights up on the wrist"],
    acknowledged: ["05", "Service on the way", "The guest stays in the moment"]
  };

  var lightPercent = [0, 35, 68, 100];

  function initialize(root) {
    if (!root || root.dataset.ctlReady === "true") return;
    root.dataset.ctlReady = "true";

    var timers = [];
    var activeRequest = null;
    var phase = "idle";
    var lightLevel = 2;
    var watchPinned = false;
    var watchHovered = false;

    var step = root.querySelector("[data-ctl-step]");
    var statusTitle = root.querySelector("[data-ctl-status-title]");
    var statusDetail = root.querySelector("[data-ctl-status-detail]");
    var resetButton = root.querySelector("[data-ctl-reset]");
    var signal = root.querySelector(".ctl-signal");
    var watchScreen = root.querySelector(".ctl-watch-screen");
    var watchPulse = root.querySelector(".ctl-watch-pulse");
    var watchMessage = root.querySelector("[data-ctl-watch-message]");
    var focusMessage = root.querySelector("[data-ctl-focus-message]");
    var focusTitle = root.querySelector("[data-ctl-focus-title]");
    var focusStatus = root.querySelector("[data-ctl-focus-status]");
    var focusCard = root.querySelector("[data-ctl-focus-card]");
    var watchZone = root.querySelector("[data-ctl-watch]");
    var lightValue = root.querySelector("[data-ctl-light-value]");
    var powerLabel = root.querySelector("[data-ctl-power-label]");

    function clearTimers() {
      timers.forEach(function (timer) { window.clearTimeout(timer); });
      timers = [];
    }

    function setPhase(nextPhase) {
      Object.keys(phaseCopy).forEach(function (key) {
        root.classList.remove("ctl-phase-" + key);
      });
      phase = nextPhase;
      root.classList.add("ctl-phase-" + phase);

      var copy = phaseCopy[phase];
      step.textContent = copy[0];
      statusTitle.textContent = activeRequest ? requestCopy[activeRequest].name : copy[1];
      statusDetail.textContent = phase === "idle" ? copy[2] : copy[1];
      resetButton.disabled = phase === "idle";

      var awake = phase === "received" || phase === "acknowledged";
      watchScreen.classList.toggle("ctl-awake", awake);
      watchPulse.classList.toggle("ctl-awake", awake);
      focusStatus.textContent = awake ? "Received" : "Standby";

      if (awake && activeRequest) {
        var message = phase === "acknowledged" ? "Acknowledged / On the way" : requestCopy[activeRequest].watch;
        watchMessage.textContent = message;
        focusMessage.textContent = requestCopy[activeRequest].watch;
        focusTitle.textContent = requestCopy[activeRequest].name;
      }
    }

    function resetScenario() {
      clearTimers();
      activeRequest = null;
      root.querySelectorAll(".ctl-hotspot").forEach(function (button) {
        button.classList.remove("ctl-is-active", "ctl-is-pressed");
      });
      signal.classList.remove("ctl-from-bill");
      watchMessage.textContent = "Receiver ready";
      focusMessage.textContent = "Receiver ready";
      focusTitle.textContent = "Ready for service";
      setPhase("idle");
    }

    function runScenario(request) {
      clearTimers();
      activeRequest = request;
      var callButton = root.querySelector(".ctl-hotspot-call");
      var billButton = root.querySelector(".ctl-hotspot-bill");
      callButton.classList.toggle("ctl-is-active", request === "call");
      billButton.classList.toggle("ctl-is-active", request === "bill");
      callButton.classList.toggle("ctl-is-pressed", request === "call");
      billButton.classList.toggle("ctl-is-pressed", request === "bill");
      signal.classList.toggle("ctl-from-bill", request === "bill");
      setPhase("pressed");

      timers = [
        window.setTimeout(function () {
          callButton.classList.remove("ctl-is-pressed");
          billButton.classList.remove("ctl-is-pressed");
          setPhase("sending");
        }, 320),
        window.setTimeout(function () { setPhase("received"); }, 1450),
        window.setTimeout(function () { setPhase("acknowledged"); }, 3600),
        window.setTimeout(resetScenario, 6500)
      ];
    }

    function setLight(level) {
      root.classList.remove("ctl-light-0", "ctl-light-1", "ctl-light-2", "ctl-light-3");
      lightLevel = Math.max(0, Math.min(3, level));
      root.classList.add("ctl-light-" + lightLevel);
      if (lightValue) lightValue.textContent = lightPercent[lightLevel] + "%";
      if (powerLabel) powerLabel.textContent = lightLevel === 0 ? "LIGHT ON" : "LIGHT OFF";
      root.querySelectorAll("[data-ctl-power]").forEach(function (button) {
        button.setAttribute("aria-pressed", lightLevel > 0 ? "true" : "false");
      });
    }

    function refreshWatchFocus() {
      var focused = watchPinned || watchHovered;
      root.classList.toggle("ctl-watch-focused", focused);
      watchZone.setAttribute("aria-pressed", watchPinned ? "true" : "false");
      focusCard.setAttribute("aria-hidden", focused ? "false" : "true");
    }

    root.querySelectorAll("[data-ctl-call]").forEach(function (button) {
      button.addEventListener("click", function () { runScenario("call"); });
    });
    root.querySelectorAll("[data-ctl-bill]").forEach(function (button) {
      button.addEventListener("click", function () { runScenario("bill"); });
    });
    root.querySelectorAll("[data-ctl-power]").forEach(function (button) {
      button.addEventListener("click", function () { setLight(lightLevel === 0 ? 2 : 0); });
    });

    var dimButton = root.querySelector("[data-ctl-dim]");
    if (dimButton) {
      dimButton.addEventListener("click", function () {
        setLight(lightLevel === 0 ? 1 : lightLevel === 3 ? 1 : lightLevel + 1);
      });
    }

    var lightDown = root.querySelector("[data-ctl-light-down]");
    var lightUp = root.querySelector("[data-ctl-light-up]");
    if (lightDown) lightDown.addEventListener("click", function () { setLight(Math.max(1, (lightLevel || 1) - 1)); });
    if (lightUp) lightUp.addEventListener("click", function () { setLight(Math.min(3, (lightLevel || 1) + 1)); });

    watchZone.addEventListener("mouseenter", function () { watchHovered = true; refreshWatchFocus(); });
    watchZone.addEventListener("mouseleave", function () { watchHovered = false; refreshWatchFocus(); });
    watchZone.addEventListener("focus", function () { watchHovered = true; refreshWatchFocus(); });
    watchZone.addEventListener("blur", function () { watchHovered = false; refreshWatchFocus(); });
    watchZone.addEventListener("click", function () { watchPinned = !watchPinned; refreshWatchFocus(); });
    watchZone.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        watchPinned = false;
        refreshWatchFocus();
      }
    });

    var closeButton = root.querySelector("[data-ctl-focus-close]");
    closeButton.addEventListener("click", function () {
      watchPinned = false;
      watchHovered = false;
      refreshWatchFocus();
    });

    resetButton.addEventListener("click", resetScenario);

    root.addEventListener("shopify:section:unload", clearTimers);
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll("[data-call-table-lamp]").forEach(initialize);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initializeAll(event.target);
  });
})();
